module.exports = ["toEnglish","toEdition"]


//////////////////
// WEBPACK FOOTER
// ../~/espn-url/langs.json
// module id = 637
// module chunks = 0